import React from 'react';
import { Hero } from '../components/home/Hero';
import { MarqueeStrip } from '../components/home/MarqueeStrip';
// import { About } from '../components/home/About';
import { Products } from '../components/home/Products'; // uncommented
// import { InstagramFeed } from '../components/home/InstagramFeed'; // commented out for now — Follow Our Journey

export function HomePage() {
  return (
    <>
      <Hero />
      <MarqueeStrip />
      {/* <About /> */}
      <Products />
      {/* <InstagramFeed /> */}
    </>
  );
}

